var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pt-30 pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                { ref: "form", attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否免费投放：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.free_invest_device,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "free_invest_device", $$v)
                          },
                          expression: "form.free_invest_device",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "慢充充电宝：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.mc_cdb_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mc_cdb_buy_price", $$v)
                                },
                                expression: "form.mc_cdb_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "快充充电宝：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.kc_cdb_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "kc_cdb_buy_price", $$v)
                                },
                                expression: "form.kc_cdb_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "慢充纯密码线：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.mc_mmx_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mc_mmx_buy_price", $$v)
                                },
                                expression: "form.mc_mmx_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "快充纯密码线：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.kc_mmx_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "kc_mmx_buy_price", $$v)
                                },
                                expression: "form.kc_mmx_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "慢充蓝牙密码线：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.mc_lymmx_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mc_lymmx_buy_price", $$v)
                                },
                                expression: "form.mc_lymmx_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mr-20",
                          attrs: { label: "快充蓝牙密码线：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.kc_lymmx_buy_price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "kc_lymmx_buy_price", $$v)
                                },
                                expression: "form.kc_lymmx_buy_price",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.editbuyprice()
                        },
                      },
                    },
                    [_vm._v("立即提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }